import type { Meta, StoryFn } from '@storybook/react';
import { useState } from 'react';

import { Pagination } from '@pega/cosmos-react-core';
import type { PaginationProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Pagination',
  component: Pagination
} as Meta;

export const PaginationDemo: StoryFn<PaginationProps> = (args: PaginationProps) => {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Pagination
      total={args.total}
      pageSize={args.pageSize}
      pageNumber={currentPage}
      onPageChange={pageNumber => setCurrentPage(pageNumber)}
    />
  );
};

PaginationDemo.args = {
  total: 50,
  pageSize: 10
};

PaginationDemo.argTypes = {
  total: { control: { type: 'number' } },
  pageSize: { control: { type: 'number' } }
};
